<template lang="pug">
#content
  header.header
    h2 访客细查详情
      .tip （如果您需要在访问路径中查看到点击行为，请先
        a.clickable(
          target="_blank",
          href="/setting/trans"
          ) 设置事件转化
        | ）
  .content
    .detail-wrap
      .form
        .detail-title
          .detail-head
            img(src="https://p2.ssl.qhimg.com/t017447234f2230493e.png")
          .detail-info
            .item
              .label 访客ID：
              .control(:title="profile.guid") {{profile.guid}}
            .item
              .label 所在地区：
              .control(:title="profile.area") {{profile.area}}
        .item
          .label 最近访问时间：
          .control(:title="profile.last_visittime") {{profile.last_visittime}}
        .item
          .label 首次访问时间：
          .control(:title="profile.first_visittime") {{profile.first_visittime}}
        .item
          .label 首次访问来源：
          .control(:title="profile.first_source") {{profile.first_source}}
        .item
          .label 首次访问设备：
          .control(:title="profile.first_devtype") {{profile.first_devtype}}
        .item
          .label 首次操作系统：
          .control(:title="profile.first_os") {{profile.first_os}}
        .item
          .label 首次分辨率：
          .control(:title="profile.first_ds") {{profile.first_ds}}
        .item
          .label 首次浏览器：
          .control(:title="profile.browser") {{profile.browser}}
        .item
          .label 首次运营商：
          .control(:title="profile.network") {{profile.network}}
    .list-wrap
      timeSpan(
        @change="onTimespanChange")
      .zone
        table.data-table
          thead
            tr
              th(style="width: 230px;") 访问日期
              th(style="width: 50px;")
              th IP地址
              th 设备类型
              th 地域
              th 来源
              th 搜索词
              th.text-right 访问时间
          tbody
            tr(v-if="isLoading")
              td.loading(colspan="8" style="text-align:center")
                img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif")
            tr(v-show="detailList.length === 0 && !isLoading")
              td(colspan="8" style="text-align:center")
                | 暂无相关数据
            template(v-for="item in detailList" v-show="!isLoading")
              template(v-for="infoItem,index in item.detail")
                tr.info
                    td(:rowspan="item.rowspan",
                      v-show="index == 0",
                      style="border-right: 1px solid #DADFE6;"
                    ) {{item.date}} (共{{item.detail.length}}次访问)
                    td.pointer(
                      style="width: 50px;",
                      @click="toggleDetail(item, infoItem)"
                    )
                      b.arrow-r {{infoItem.expanded ? '▾' : '▸'}}
                    td {{infoItem.ip | ipFilter}}
                    td {{infoItem.devtype}}
                    td {{infoItem.area}}
                    td(:title="infoItem.source") {{infoItem.source}}
                    td(:title="infoItem.keyword") {{infoItem.keyword || '--'}}
                    td.text-right {{infoItem.begintime}}
                tr.toggle-detail(v-if="infoItem.expanded",
                    v-for="detailItem in infoItem.detl"
                  )
                    td
                    td(colspan="5") {{detailItem | detailFilter}}
                    td.text-right {{detailItem.visit_time}}
                
        v-pagination(
          :total="total",
          :pn="pn",
          :ps="ps",
          v-if="total > ps",
          @updatepage="updatePage")
  site-footer
</template>

<script>
/* global _ */
import Store from '../../store/store.js'
import qs from 'query-string'
export default {
  store: Store,
  data () {
    return {
      start: '',
      end: '',
      isLoading: false,
      total: 0,
      pn: 1,
      ps: 10,
      detailList: [],
      guid: '',
      domainId: '',
      profile: {}
    }
  },
  computed: {
    uiError () {
      return this.$store.state.uiError
    }
  },
  watch: {
    uiError () {
      this.$Modal.warn(this.uiError.errMsg)
    }
  },
  filters: {
    ipFilter (ip) {
      return ip
        ? ip
          .split('.')
          .map((item, index) => {
            if (index === 3) {
              item = `${item.slice(0, -1)}*`
            }
            return item
          })
          .join('.')
        : ''
      // return ip ? ip.split('.').fill('*', 3).join('.') : ''
    },
    detailFilter (item) {
      return item.et === '0'
        ? `访问页面URL：${item.url}`
        : `点击：${item.tname}`
    }
  },
  methods: {
    gotoSetting () {
      this.$router.push('/setting/trans')
    },
    getRowSpan (item) {
      return item.detail
        .filter(item => item.expanded)
        .reduce((result, item) => {
          result += item.detl.length
          return result
        }, item.detail.length)
    },
    onTimespanChange ({ start, end }) {
      this.start = start
      this.end = end
      this.getDetailList()
    },
    updatePage (pn) {
      this.pn = pn
      this.getDetailList()
    },
    getProfile () {
      const profilePromise = this.$http.get('/api/visit/profile', {
        params: {
          guid: this.guid,
          domainId: this.domainId
        }
      })
      this.$store.dispatch('VUE_HTTP', [profilePromise]).then(res => {
        this.profile = res.profile || {}
      })
    },
    getDetailList () {
      this.isLoading = true
      const params = {
        start: this.start,
        end: this.end,
        guid: this.guid,
        domainId: this.domainId,
        pg: this.pn,
        ps: this.ps
      }
      const detailPromise = this.$http.get('/api/visit/detail', {
        params: params
      })
      this.$store.dispatch('VUE_HTTP', [detailPromise]).then(res => {
        this.isLoading = false
        if (res.errno) {
          this.total = 0
          this.detailList = []
        } else {
          this.total = res.total
          this.detailList = res.list.map((item, index) => {
            if (index === 0 && !_.isEmpty(item)) {
              item.detail[0].expanded = true
              item.rowspan = item.detail.length + item.detail[0].detl.length
            } else {
              item.rowspan = item.detail.length
            }
            return item
          })
        }
      })
    },
    toggleDetail (item, infoItem) {
      this.$set(infoItem, 'expanded', !infoItem.expanded)
      const rowspan = this.getRowSpan(item)
      this.$set(item, 'rowspan', rowspan)
    }
  },
  created () {
    const urlParams = qs.parse(location.search)
    this.guid = urlParams.guid
    this.domainId = urlParams.domainId
    this.start = urlParams.start
    this.end = urlParams.end
    this.$store.commit('SET_DATE_PARAM', {
      start: urlParams.start,
      end: urlParams.end
    })
    this.getProfile()
    this.getDetailList()
  },
  destroyed () {
    this.$store.commit('SET_DATE_PARAM', {
      start: '',
      end: ''
    })
  }
}
</script>

<style scoped>
.header {
  background-color: #fff;
  border-bottom: 1px solid #dadfe6;
  h2 {
    color: #455770;
  }
  .fa {
    margin-left: 5px;
  }
}
.content {
  margin: 10px 0;
  display: flex;
}
.form {
  padding: 20px;
  .label,
  .control {
    line-height: 32px;
    text-align: left;
    min-width: auto;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 200px;
  }
}
.detail-wrap {
  max-width: 280px;
  border: 1px solid #dadfe6;
  margin-right: 20px;
  background: #fff;
  .detail-title {
    margin-bottom: 15px;
    overflow: hidden;
    .detail-head,
    .detail-info {
      float: left;
    }
    .detail-info {
      padding: 5px 15px;
      width: 150px;
      .control {
        max-width: 90px;
      }
    }
    .item {
      margin: 0;
      width: 155px;
    }
  }
}
.list-wrap {
  flex: 1;
  .q-timespan {
    margin-top: 0;
    line-height: 28px;
    vertical-align: baseline;
  }
}
.arrow-r {
  display: inline-block;
  width: 14px;
  height: 14px;
  font-size: 14px;
  text-align: right;
  color: #999;
}
.data-table {
  table-layout: fixed;
  .text-left {
    text-align: right;
  }
  thead th,
  tbody td {
    min-width: 50px;
    max-width: 400px;
    padding: 0 5px 0 20px;
    &:last-child {
      padding-right: 20px;
    }
  }
  tbody {
    tr.toggle-detail {
      background: #f5f8fb;
    }
    tr.info {
      background: #fff;
    }
  }
  .text-right {
    width: 180px;
  }
}
.pointer {
  cursor: pointer;
}
.tip {
  color: #999;
  font-size: 12px;
  margin-left: 5px;
  display: inline-block;
  vertical-align: middle;
  .clickable {
    cursor: pointer;
    text-decoration: underline;
    &:hover {
      color: #57e69e;
    }
  }
}
</style>



// WEBPACK FOOTER //
// personDetail.vue?b53593d2